import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-front-games-form',
  templateUrl: './front-games-form.component.html',
  styleUrls: ['./front-games-form.component.scss']
})
export class FrontGamesFormComponent implements OnInit {

  public initData : any = {};
  public data : any = {status: 1};
  public gamesCode:any = [];
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      this.init(params['game_view_uuid']);
    });
  }

  ngOnInit(): void {
    this.init()
  }

  async init(game_view_uuid = null) {
    this.initData = await this.http.post('/admin/app/game/banner/init');
    if (this.initData.category.length <= 0) {
      this.http.notify("Category required before proceed. Add category from frontend > category management first.")
      this.http.naviBack();
    }
    if (this.initData.games.length <= 0) {
      this.http.notify("Games required before proceed. Add games from setting > game management first.")
      this.http.naviBack();
    }

    if (game_view_uuid) {
      this.data = await this.http.post("/admin/app/games/view/get", {game_view_uuid});
    }

    this.updateIntegration();
  }

  updateIntegration() {
    const integration_id = this.data.integration_id;
    if (integration_id == 'manual') {
      this.gamesCode = [];
      this.data.integration_code = null;
    } else {
      let obj = this.initData.integration.find(o => o.id == integration_id);
      this.gamesCode = obj.games;
    }

  }

  async loadFile(fileInput: any) {
    this.data.image = await this.http.fileChangeEvent(fileInput);
  }

  async submit() {
    if (!this.data.image) {
      return;
    }

    if (this.data.integration_id != 'manual' && !this.data.game_code) {
      return;
    }

    const s = await this.http.post('/admin/app/games/update', this.data);
    if (s['status']) {
      this.http.notify("Games view update successfully.")
      this.http.naviBack();
    }
  }
}
